module.exports = __webpack_public_path__ + "assets/img/banner-eos.5f3a1d4e.png";